export enum MarkupTypes {
  MARKUP = 'markup',
  MULTIPLIER = 'multiplier'
}
